import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { Cell, Row } from '@/main/utils/table';
import { DropdownItem } from '@/main/store/@types/dropdown.d';


import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';


export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		SkladOzn: [],
		VyrobekndOzn: [],
		Parts: [] as any[],
		Orders: [],
		Mrp: [],
		AllMrp: [] as any[],
		AllDnp: [] as any[],
		VydejMjId: [],
		DefaultPartsList: [] as any[],
		TechniciansList:[],
		ServiceJobsList:[] as any[],
		WorkshopList: [],
		CombinedMrpDnp: [] as any[]
	},
	filter: {
		ZakazkaId: null as number | null,
		ProvozovnaId: null as number | null,
		SkladOzn: null as number | null,
		ZakazkaNr: null as number | null,
		VyrobekndOzn: null as string | null,
		NdNr: null as string | null,
		EanCode: null as string | null,
		FromDate: null as string | null,
		ToDate: null as string | null,
		VydejMjId: null as number | null,
		OrderStatus: null as number | null,
		VehicleBrand: null as string | null,
		DefaultWarehouseId: null as number | null,
		IsDNPVisible: false as boolean | false,
		OrderNo: null as number | null,
		ZakaznikId: null as number | null,
		ZakazkaDruh: null as string | null,
	},
	tableSetting: {
		isEditable: true,
		columnSettings: {
			ZAKAZKA_NR: { isEditable: false, required: false, type: 'dropdown', minWidth: '120px' },
			X_VYROBEKND_OZN: { isEditable: true, required: true, type: 'dropdown', minWidth: '170px' },
			ND_NR: { isEditable: true, required: true, type: 'dropdown', minWidth: '130px' },
			TEXT: { isEditable: true, required: true, type: 'text', minWidth: '130px' },
			X_SKLAD_OZN: { isEditable: true, required: true, type: 'dropdown', minWidth: '170px' },
			X_REZERVVLASTNI: { isEditable: true, required: true, type: 'decimal', minWidth: '100px' },
			PART_MRP: { isEditable: true, required: true, type: 'dropdown', minWidth: '150px' },
			RRP_UNIT_PRICE: { isEditable: true, required: true, type: 'decimal', minWidth: '150px' },
			CONVERTED_UNIT_OF_MEASUREMENT: { isEditable: false, required: false, type: 'text', minWidth: '180px' },
			IS_ADDITIONAL: { isEditable: true, required: false, type: 'checkbox', minWidth: '100px' },
			BASE_UNIT_OF_MEASUREMENT: { isEditable: false, required: false, type: 'text', minWidth: '180px' },
			CONVERTED_QUANTITY: { isEditable: false, required: false, type: 'decimal', minWidth: '180px' },
			PRICE_PER_CONVERTED_QUANTITY: { isEditable: false, required: false, type: 'decimal', minWidth: '180px' },
			DISCOUNT_PERCENT: { isEditable: true, required: false, type: 'decimal', minWidth: '100px' },
			DISCOUNT_VAL: { isEditable: true, required: false, type: 'decimal', minWidth: '100px' },
			TECHNICIAN: { isEditable: true, required: false, type: 'dropdown', minWidth: '200px' },
			SERVICE_JOB_ID: { isEditable: true, required: false, type: 'dropdown', minWidth: '200px' },
		},
	},
	localState: {
		multipleSelection: [] as Row[],
		selectedNdRow: null as Cell[] | null,
		odpisResult: null as string[] | null,
	},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		partsListData: [] as any[],
		filter: {},
		afterRowSelection: () => {},
		IsDNPVisible: null as boolean | null,
		IsWorkshopContractOrder: false as boolean,
		OrderNo: null as number | null,
		CanAddPartOrLabour: null as boolean | null,
	},
});
